export default __webpack_public_path__ + "static/media/17.eec7332d.png";